/**
 * Route definition for the /approved page shown after admin approval.
 */
import { createFileRoute } from '@tanstack/react-router';

import ApprovedPage from '../features/auth/ApprovedPage';

export const Route = createFileRoute('/approved')({
    component: ApprovedPage,
});
